import type { PeriodDto, PeriodGranularity } from '../../../../lib/api/v2/planning'
import { cn } from '../../../../lib/utils'
import { formatPeriod, periodFromInput } from './supplier-orders-helpers'

interface PeriodInputProps {
  value: PeriodDto
  onChange: (p: PeriodDto) => void
  /** testid prefix, e.g. "planning-order-send-period" */
  testId: string
}

/**
 * Delivery period input (SOLY-PO-001): a day or one ISO week. The user toggles the granularity
 * and picks ANY date — weeks normalize to Monday→Sunday and display as « S25 · 15–21/06 ».
 * New granularities (month, range) slot in without touching consumers.
 */
export function PeriodInput({ value, onChange, testId }: PeriodInputProps) {
  const setGranularity = (g: PeriodGranularity) => onChange(periodFromInput(g, value.start))

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <div className="flex overflow-hidden rounded-md border">
        {(['Day', 'Week'] as const).map((g) => (
          <button key={g} type="button" data-testid={`${testId}-unit-${g}`}
            onClick={() => setGranularity(g)} aria-pressed={value.granularity === g}
            className={cn('px-2 py-1 text-xs font-medium',
              value.granularity === g ? 'bg-primary text-primary-foreground' : 'bg-background text-muted-foreground hover:bg-muted')}>
            {g === 'Day' ? 'Jour' : 'Semaine'}
          </button>
        ))}
      </div>
      <input type="date" value={value.start} data-testid={`${testId}-date`}
        onChange={(e) => e.target.value && onChange(periodFromInput(value.granularity, e.target.value))}
        className="rounded border px-2 py-1 text-xs" />
      {value.granularity === 'Week' && (
        <span className="text-[11px] text-muted-foreground" data-testid={`${testId}-label`}>{formatPeriod(value)}</span>
      )}
    </div>
  )
}
